import { render } from "./Home.vue?vue&type=template&id=00199883&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=00199883&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00199883"

export default script